import { render, staticRenderFns } from "./FoldingCard.vue?vue&type=template&id=6bbc0ba7&scoped=true&"
import script from "./FoldingCard.vue?vue&type=script&lang=ts&"
export * from "./FoldingCard.vue?vue&type=script&lang=ts&"
import style0 from "./FoldingCard.vue?vue&type=style&index=0&id=6bbc0ba7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbc0ba7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
